import React, { MouseEvent, useCallback } from "react";
import { Button } from "@design-system/Button/Button";
import { Tooltip } from "@design-system/Tooltip/Tooltip";

interface BulkSelectionControlProps {
    selectedCount: number;
    onClearSelection: () => void;
    size?: "md" | "lg";
    className?: string;
}

export const BulkSelectionControl: React.FC<BulkSelectionControlProps> = ({
    selectedCount,
    onClearSelection,
    size: sizeProp,
    className,
}) => {
    const size = sizeProp ?? "md";
    const handleClear = useCallback(
        (e: MouseEvent) => {
            e.stopPropagation();
            onClearSelection();
        },
        [onClearSelection],
    );

    return (
        <Tooltip content={`Deselect ${selectedCount}`}>
            <Button
                variant="primary"
                size={size}
                className={className}
                onClick={handleClear}
            >
                {selectedCount} selected
            </Button>
        </Tooltip>
    );
};
